/** Hard limits shared by server validation and the client UI. */
export const LIMITS = {
    titleMax: 200,
    descriptionMax: 2000,
    emojiMax: 16,
    itemTextMax: 500,
    noteMax: 2000,
    quantityMax: 30,
    nameMax: 50,
    itemsPerList: 500,
    itemsPerAddCall: 100,
    bodyBytesMax: 256 * 1024,
};
export const TOKEN_PREFIX = { view: 'vw_', edit: 'ed_', admin: 'ad_' };
/** admin ⊃ edit ⊃ view */
export const CAPABILITY_RANK = { view: 1, edit: 2, admin: 3 };
export function hasCapability(actual, required) {
    return CAPABILITY_RANK[actual] >= CAPABILITY_RANK[required];
}
//# sourceMappingURL=limits.js.map